import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentDmsStructureValueType on DmsStructureValueType {
    structureId
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentDmsStructureValueTypeFragment,
  ents.core.dms.data.Value.Type.Structure
>({
  structureId: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
})
